import {
  TOOLBAR_CONTROL_WIDTH_SX,
  createToolbarSelectSx,
  createToolbarTextFieldSx,
  toolbarMenuItemSx,
} from "./toolbarControlStyles";

export const ACTIVITY_TOOLBAR_CONTROL_WIDTH_SX = TOOLBAR_CONTROL_WIDTH_SX;

export const activityToolbarRowSx = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.25,
  minWidth: 0,
};

export const activityToolbarDropdownGroupSx = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  gap: 1.25,
  width: { xs: "100%", md: "auto" },
  maxWidth: "100%",
  minWidth: 0,
};

export const activityToolbarTextFieldSx = {
  ...createToolbarTextFieldSx({ outlineSx: { borderColor: "#98A2B3" } }),
  minWidth: 0,
};

export const activityToolbarSelectSx = createToolbarSelectSx({
  outlineSx: { borderColor: "#98A2B3" },
  textFontWeight: 400,
});

export const activityToolbarMenuItemSx = toolbarMenuItemSx;
